import { getPredicateKey } from '../alerts.types';
import { mockedDevice } from './devices';
import mockedRequester from './mockedRequester';
import { mockedPlot } from './plots';
export const mockedPlotId = mockedPlot.id;
export const mockedDeviceId = mockedDevice.id;
export const mockedAlertSources = ['GDD', 'U'];
export const cumulGtRR = {
    source: 'RR',
    op: 'cumul-gt',
    params: {
        threshold: 400,
        since: 1633953379,
        isRepeatable: true,
        initialAcc: { plots: { [mockedPlotId]: 9 }, devices: { [mockedDeviceId]: 0 }, stations: {} }
    }
};
export const gtHumidityPredicate = {
    source: mockedAlertSources[1],
    op: 'gt',
    params: { threshold: 70 }
};
export const mockedAlert = {
    _id: 'mongo-alert-id',
    isVoiceCallEnabled: false,
    legacyId: 0,
    userId: 0,
    updatedAt: 1636110,
    isActive: true,
    name: `My alert 0`,
    currentlyTriggerCount: 0,
    predicates: {
        [getPredicateKey(gtHumidityPredicate)]: gtHumidityPredicate,
        [getPredicateKey(cumulGtRR)]: cumulGtRR
    },
    statuses: {
        plots: {
            [mockedPlotId]: {
                [getPredicateKey(gtHumidityPredicate)]: {
                    inProgress: true,
                    inProgressSince: 1633953379,
                    triggerVal: 71
                },
                [getPredicateKey(cumulGtRR)]: { inProgress: false, acc: 2, inProgressSince: 1633953379 }
            }
        },
        devices: {
            [mockedDeviceId]: {
                [getPredicateKey(gtHumidityPredicate)]: {
                    inProgress: false,
                    inProgressSince: 1633953379,
                    triggerVal: 71
                },
                [getPredicateKey(cumulGtRR)]: { inProgress: false, acc: 2, inProgressSince: 1633953379 }
            }
        },
        stations: {}
    },
    targets: { plots: [mockedPlotId], devices: [mockedDeviceId], stations: [] },
    deviceIdPerStationId: {}
};
const mock = {
    get: () => mockedRequester(mockedAlert, 'alerts.get'),
    getMany: mockedRequester([mockedAlert], 'alerts.getMany'),
    create: () => mockedRequester(mockedAlert, 'alerts.create'),
    replace: () => mockedRequester(mockedAlert, 'alerts.replace'),
    update: () => mockedRequester(mockedAlert, 'alerts.update'),
    delete: mockedRequester(undefined, 'alerts.delete')
};
export default mock;
